import { useLocation, useNavigate } from '@tanstack/react-router';

import { usePageNavigation } from '@src/context/PageNavigationContext';
import { handleInPageSmoothScroll } from '@src/hooks/useSmoothScroll';

/**
 * Custom hook to encapsulate navigation and scroll-to-top logic.
 * Also triggers page reset when navigating to the same page.
 * @returns {function(string): void} The handleNavigateToTop function.
 */
export function useNavigateToTop() {
  const navigate = useNavigate();
  const location = useLocation();
  const { triggerReset } = usePageNavigation();

  const handleNavigateToTop = (path, targetId) => {
    // Check if navigating to the same page and trigger reset
    if (path === location.pathname) {
      triggerReset();
    }

    // Navigate using the hook
    navigate({ to: path });
    // console.log(path, targetId)
    // Scroll to the top of the page
    window.scrollTo(0, 0);
    if (targetId) {

      requestAnimationFrame(() => {
        handleInPageSmoothScroll(null, targetId);
      });
    }
  };

  return handleNavigateToTop;
}
